exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-ca75faa6]{font-family:Proxima0,sans-serif}", ""]);

// exports
